'use strict';

(function () {
  var slide = document.querySelector('.slider--simple');

  if (!slide) {
    return;
  }

  var controls = slide.querySelector('.slider__controls');
  var controlsNext = slide.querySelector('.slider__arrow-right');
  var controlsPrev = slide.querySelector('.slider__arrow-left');

  var slideOptions = {
    type: 'carousel',
    perView: 1
  };

  var sliderSimple = function sliderSimple() {
    var glide = new Glide('.slider--simple__wrap', slideOptions);
    glide.mount();

    // controls
    if (controls) {
      controlsNext.addEventListener('click', function () {
        glide.go('>');
      });

      controlsPrev.addEventListener('click', function () {
        glide.go('<');
      });
    }
  };

  sliderSimple();
})();